export default {
'slug': null,
'active': null,
'createdAt': null,
'createdBy': null,
'createdByUser': null,
'dateModified': null,
'modifiedBy': null,
'modifiedByUser': null,
'checkedOut': null,
'checkedOutBy': null,
'checkedOutByUser': null,
'order': null,
'deleted': null,
}
